// extracted by mini-css-extract-plugin
module.exports = {"meal":"meal-1-eWm","meal_aggregation":"meal_aggregation-3pD3y"};